<script setup lang="ts">
import { ref } from 'vue';
import { dateHelpers, AgeSelector } from '@hfc/ui-core';
import ArrowTour from '@/shared/infrastructure/components/ArrowTour.vue';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

interface EmitInterface {
  (event: 'goToSection', value: number): void;
}

const emits = defineEmits<EmitInterface>();

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const { getDateFromAge } = dateHelpers();

const age = ref(smallBusinessState.value.application.sample_employee.date_of_birth || getDateFromAge(30));

const changeSampleApplicant = async (age: number): Promise<void> => {
  await smallBusinessStore.editSampleApplicant({
    ...smallBusinessState.value.application.sample_employee,
    dependents: [],
    date_of_birth: age,
  });

  await smallBusinessStore.fetchAvailablePlans();
};

const showDetailedEmployeeStep = async (): Promise<void> => {
  emits('goToSection', 1);
  await smallBusinessStore.updateDetailedEmployeesFlag(true);
};

const goToEmployeeDetails = (): void => {
  emits('goToSection', 1);
};
</script>
<template>
  <div class="-mx-3 sm:-mx-6 px-3 sm:px-6 py-3 bg-blue-400">
    <div class="w-full xl:max-w-[88rem] 2xl:max-w-[112rem] mx-auto xl:px-64 flex flex-col lg:flex-row items-start lg:items-center gap-2 font-medium text-md">
      <div class="relative w-full lg:w-auto">
        <ArrowTour class="hidden xl:block absolute right-full top-1/2 -translate-y-[calc(50%+6px)] -mr-3 w-14 h-14 " />
        <div class="flex flex-row bg-white items-center px-4 py-1 rounded-lg min-h-[52px]">
          <template v-if="!smallBusinessState.application.detailed_employees">
            <span>Prices below are based on a single</span>
            <div class="mx-1">
              <AgeSelector v-model="age" :start-age="18" css="w-18" @update:model-value="(val: number|Array<number>) => changeSampleApplicant(val as number)" />
            </div>
            <span>year old employee.</span>
          </template>
          <span v-else>Prices below are based on <button class="underline cursor-pointer" @click="goToEmployeeDetails">Employee Details</button>.</span>
        </div>
      </div>
      <p v-if="!smallBusinessState.application.detailed_employees" class="text-white ml-2"><button class="underline cursor-pointer" @click="showDetailedEmployeeStep">Add Employee Details</button><br> to get an exact quote.</p>
    </div>
  </div>
</template>
